export const CUSTOMER_INSTALLMENT_STATUS = {
  PENDING: 1,
  SCHEDULED_TODAY: 2,
  SCHEDULED_NEXT: 3,
  SCHEDULED: 4,
  PAID: 5,
};
